import axios from "axios";
import { listRequestBody } from "../utils/listPagination";

const BASE = "/api/subjects";

export function list(options = {}) {
  return axios.post(`${BASE}/list`, listRequestBody(options));
}

export function create(data) {
  return axios.post(BASE, data);
}

export function remove(id) {
  return axios.delete(`${BASE}/${id}`);
}
